<template>
  <div>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Preview Advert"
      id="admin_preview_advert_edit_details"
    >
      <v-btn
        @click="$router.go(-1)"
        small
        rounded
        class="mr-4"
        outlined
        color="default"
      >
        <v-icon left>mdi-cancel</v-icon> Cancel Delete
      </v-btn>
    </CardedSectionHeader>
    <AdvertView :advert="advert"></AdvertView>
    <CardedSectionHeader
      icon="mdi-trash-can"
      label="Advert Delete Concent Form"
      id="admin_advert_delete_form"
    >
    </CardedSectionHeader>
    <DeleteConcentForm
      ref_prop="advert_delete_form_ref"
      id="advert_delete_form"
      message="<b>Delete was succesfull</b> <br/> The advert has been removed"
      :is_loading="is_loading"
      :seed="{advert:[$route.params.id]}"
      @on-delete-success="on_success"
      @on-hide-loader="$emit('on-hide-loader')"
      @on-show-loader="$emit('on-show-loader')"
    >
    </DeleteConcentForm>
  </div>
</template>

<script>
import DeleteConcentForm from "../../../components/DeleteConcentForm";
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import AdvertView from "../../../components/AdvertView";
export default {
  name: "AdminAdvertsEdit",
  components: {
    CardedSectionHeader,
    DeleteConcentForm,
    AdvertView
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      this_advert_key: "this_advert_key_1",
      this_advert_key_truck: 1,
      advert: Utils.get_default_advert(),
      advert_id: 0,
    };
  },
  methods: {
    load_advert() {
      this.$emit("on-show-loader");
      ServerClient.Adverts.get_advert_details(
        {
          id: this.advert_id,
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.advert = res;
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading advert for deleting in admin delete advert view",
            errors
          );
        }
      );
    },
    on_success() {
      this.$router.push("/admin/adverts/list");
    },
  },
  mounted() {
    this.advert_id = this.$route.params.id;
    this.$emit("set-page-attributes", {
      title: "Remove  Ad",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Adverts",
          disabled: false,
          href: "/admin/adverts",
        },
        {
          text: "list",
          disabled: false,
          href: "/admin/adverts/list",
        },
        {
          text: "view",
          disabled: false,
          href: "/admin/adverts/list/view/" + this.advert_id,
        },
        {
          text: "Delete",
          disabled: true,
          href: "/admin/adverts/list/view/" + this.advert_id + "/delete",
        },
      ],
    });
    this.load_advert();
  },
};
</script>